import { UserRole } from '@on3/ui-lib/api/schema/custom-contracts';

const accountingAdmin = [
  UserRole.Developer,
  UserRole.AccountingAdmin,
  UserRole.PublisherDashboardAdmin,
];

const administratorLevel = [UserRole.Administrator, UserRole.Developer];

const adminPublisher = [UserRole.Developer, UserRole.PublisherDashboardAdmin];

const customerServiceLevel = [
  UserRole.Cs1,
  UserRole.CSAdmin,
  UserRole.Administrator,
  UserRole.Developer,
];

const developerLevel = [UserRole.Developer];

const graphicEditsLevel = [
  UserRole.GraphicEdits,
  UserRole.Rdb5,
  UserRole.Administrator,
  UserRole.Developer,
];

const nilDisputeLevel = [UserRole.NilDisputeAdmin, UserRole.Developer];

const nilValuationAdmin = [
  UserRole.NilValuationAdmin,
  UserRole.Administrator,
  UserRole.Developer,
];

const publisherLevel = [
  UserRole.PublisherDashboardAdmin,
  UserRole.PublisherDashboard,
  UserRole.Developer,
];

const rdb1Level = [
  UserRole.Rdb1,
  UserRole.Rdb2,
  UserRole.Rdb3,
  UserRole.Rdb4,
  UserRole.Rdb5,
  UserRole.Administrator,
  UserRole.Developer,
];

const rdb2Level = [
  UserRole.Rdb2,
  UserRole.Rdb3,
  UserRole.Rdb4,
  UserRole.Rdb5,
  UserRole.Administrator,
  UserRole.Developer,
];

const rdb3Level = [
  UserRole.Rdb3,
  UserRole.Rdb4,
  UserRole.Rdb5,
  UserRole.Administrator,
  UserRole.Developer,
];

const rdb4Level = [
  UserRole.Rdb4,
  UserRole.Rdb5,
  UserRole.Administrator,
  UserRole.Developer,
];

const rdb5Level = [UserRole.Rdb5, UserRole.Administrator, UserRole.Developer];

const showLevel = [
  UserRole.Administrator,
  UserRole.Developer,
  UserRole.ShowsAdmin,
];

const gameScorer = [
  UserRole.Administrator,
  UserRole.Developer,
  UserRole.Rdb1,
  UserRole.Rdb2,
  UserRole.Rdb3,
  UserRole.Rdb4,
  UserRole.Rdb5,
  UserRole.GameScorer,
];

const rosterEditor = [UserRole.Developer, UserRole.Rdb5];

const trendingAdmin = [
  UserRole.Administrator,
  UserRole.Developer,
  UserRole.TrendingAdmin,
];

const socialAdmin = [UserRole.SocialAdmin, UserRole.Developer];

const notificationsAdmin = [
  UserRole.Notifications,
  UserRole.Developer,
  UserRole.Administrator,
  UserRole.Rdb5,
  UserRole.SocialAdmin,
];

const recruitsAdmin = [...rdb3Level];
const profileAdmin = [...recruitsAdmin, UserRole.ProfileAdmin];

export {
  accountingAdmin,
  administratorLevel,
  adminPublisher,
  customerServiceLevel,
  developerLevel,
  gameScorer,
  graphicEditsLevel,
  nilDisputeLevel,
  nilValuationAdmin,
  notificationsAdmin,
  profileAdmin,
  publisherLevel,
  rdb1Level,
  rdb2Level,
  rdb3Level,
  rdb4Level,
  rdb5Level,
  recruitsAdmin,
  rosterEditor,
  showLevel,
  socialAdmin,
  trendingAdmin,
};
